<template>
  <input
    :value="value"
    class="input"
    type="text"
    :readonly="true"
    :placeholder="placeholder | translate"
    @change="onDateChange($event.target.value)"/>
</template>

<script>
  import Flatpickr from 'flatpickr'
  import { Swedish } from 'flatpickr/dist/l10n/sv'
  import { english } from 'flatpickr/dist/l10n/default'
  import moment from 'moment'

  export default {
    name: 'flatpicker-component',
    props: {
      config: {
        type: Object,
        default: () => {}
      },
      placeholder: {
        type: String,
        default: 'Pick date'
      },
      selectedDates: [String, Array],
      value: String
    },
    data () {
      return {
        flatpicker: null
      }
    },
    computed: {
      static () {
        return !!this.config.static
      },
      lang () {
        return this.$language.current
      }
    },
    methods: {
      onDateChange (newValue) {
        if (!moment(newValue, moment.ISO_8601).isValid()) {
          this.flatpicker.setDate(null)
        }
      },
      onDateSelected (selectedDates, dateStr) {
        this.$emit('onDateSelected', selectedDates)
      },
      setLocale () {
        if (this.lang === 'sv') {
          this.config.locale = Swedish
        } else {
          this.config.locale = english
        }
      },
      initFlatPciker () {
        this.setLocale()
        this.config.defaultDate = this.selectedDates
        this.config.onValueUpdate = this.onDateSelected
        this.flatpicker = new Flatpickr(this.$el, this.config)
      }
    },
    created () {
      window.addEventListener('keydown', this.onEnterDate)
      this.$root.$on('languageChanged', this.initFlatPciker)
    },
    mounted () {
      if (!this.flatpicker) {
        this.initFlatPciker()
      }
    },
    beforeDestroy () {
      if (this.flatpicker && !this.static) {
        this.flatpicker.destroy()
        this.flatpicker = null
      }
      window.removeEventListener('keydown', this.onEnterDate)
    }
  }
</script>

<style lang="sass">
</style>
